import axios from "axios";
// import { setupAuthInterceptors } from "./authInterceptor";
import { API_CONFIG } from "./config";

// Создаем экземпляр axios с базовой конфигурацией
const apiClient = axios.create({
  baseURL: API_CONFIG.baseURL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: API_CONFIG.timeout,
});

// // Функция для установки токена авторизации
// export const setAuthToken = (token: string) => {
//   if (token) {
//     apiClient.defaults.headers.common["Authorization"] = `Bearer ${token}`;
//   } else {
//     delete apiClient.defaults.headers.common["Authorization"];
//   }
// };

// Настраиваем перехватчики для автоматического обновления токена
// setupAuthInterceptors(apiClient);

export default apiClient;
